import { RESCHEDULE_HISTORY_FILTER_OPTIONS } from '../../../constants/settings';
import { useRescheduleHistoryContext } from '../../../contexts/RescheduleHistoryProvider';
import FilterButton from '../../CommonComps/Buttons/FilterButton';

const RescheduleHistoryFilterActions = () => {
  // integration of context hooks here
  const { rescheduleHistoryType, setRescheduleHistoryType } =
    useRescheduleHistoryContext();

  // handler function to switching reschedule history filter types declared here
  const handleFilterRescheduleHistory = (type: string) => {
    setRescheduleHistoryType(type);
  };

  // rendering reschedule history filer actions component here
  return (
    <div className='grid grid-cols-[repeat(2,_110px)] md:grid-cols-[repeat(2,_120px)]'>
      {RESCHEDULE_HISTORY_FILTER_OPTIONS.map((option) => (
        <FilterButton
          key={option.id}
          keyId={option.id}
          btnText={option.label}
          color={option.color}
          layoutId='filter-reschedule-underline'
          selectedValue={rescheduleHistoryType}
          onClick={(type) => handleFilterRescheduleHistory(type)}
        />
      ))}
    </div>
  );
};

export default RescheduleHistoryFilterActions;
